import React, { useState, useEffect } from "react";

export default function TRAINtest(props) {
  const correctAnswers = [0, 1, 1, 3, 2, 0, 1, 1, 2, 2, 1, 0, 1, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1];
  const que = {
    q1: {
      string: "1. A train covers a distance of 480 km at a speed of 80 km/h. What is the time taken by the train to cover the distance?",
      options: ["4 hours", "6 hours", "8 hours", "10 hours"],
      ans: 0
    },
    q2: {
      string: "2. A train is running at a speed of 90 km/h. How far will it travel in 3 hours?",
      options: ["270 km", "300 km", "320 km", "330 km"],
      ans: 1
    },
    q3: {
      string: "3. Two trains of lengths 200 meters and 300 meters are running at speeds of 60 km/h and 80 km/h respectively in the same direction. In how many seconds will the faster train cross the slower one?",
      options: ["25 seconds", "30 seconds", "35 seconds", "40 seconds"],
      ans: 1
    },
    q4: {
      string: "4. A train crosses a pole in 20 seconds. What is the length of the train if the speed of the train is 36 km/h?",
      options: ["50 meters", "60 meters", "70 meters", "80 meters"],
      ans: 3
    },
    q5: {
      string: "5. A train travels a distance of 540 km at a uniform speed. If the speed of the train is 60 km/h, how long will it take to cover the distance?",
      options: ["7 hours", "8 hours", "9 hours", "10 hours"],
      ans: 2
    },
    q6: {
      string: "6. Two trains of lengths 100 meters and 150 meters are running at speeds of 45 km/h and 60 km/h respectively in opposite directions. In how many seconds will they cross each other?",
      options: ["8 seconds", "9 seconds", "10 seconds", "12 seconds"],
      ans: 0
    },
    q7: {
      string: "7. A train 100 meters long is running at a speed of 72 km/h. How long will it take to cross a platform 300 meters long?",
      options: ["12 seconds", "15 seconds", "18 seconds", "20 seconds"],
      ans: 1
    },
    q8: {
      string: "8. A train covers a distance of 240 km at a uniform speed. If the speed of the train is 60 km/h, what is the time taken by the train?",
      options: ["3 hours", "4 hours", "5 hours", "6 hours"],
      ans: 1
    },
    q9: {
      string: "9. A train is running at a speed of 36 km/h. How long will it take to cover a distance of 540 meters?",
      options: ["9 seconds", "12 seconds", "15 seconds", "18 seconds"],
      ans: 2
    },
    q10: {
      string: "10. Two trains of lengths 120 meters and 180 meters are running at speeds of 45 km/h and 60 km/h respectively in opposite directions. In how many seconds will they cross each other?",
      options: ["8 seconds", "10 seconds", "12 seconds", "15 seconds"],
      ans: 2
    },
    q11: {
      string: "11. A train passes a stationary man in 3 seconds and passes a stationary pole in 2 seconds. What is the length of the train if the speed of the train is 36 km/h?",
      options: ["40 meters", "50 meters", "60 meters", "70 meters"],
      ans: 1
    },
    q12: {
      string: "12. A train is running at a speed of 108 km/h. How far will it travel in 10 minutes?",
      options: ["18 km", "20 km", "25 km", "30 km"],
      ans: 0
    },
    q13: {
      string: "13. A train travels a distance of 1440 km at a uniform speed. If the speed of the train is 80 km/h, how long will it take to cover the distance?",
      options: ["16 hours", "18 hours", "20 hours", "22 hours"],
      ans: 1
    },
    q14: {
      string: "14. Two trains of lengths 150 meters and 200 meters are running at speeds of 54 km/h and 72 km/h respectively in the same direction. In how many seconds will the faster train cross the slower one?",
      options: ["10 seconds", "12 seconds", "15 seconds", "18 seconds"],
      ans: 2
    },
    q15: {
      string: "15. A train is running at a speed of 72 km/h. How far will it travel in 25 seconds?",
      options: ["500 meters", "600 meters", "700 meters", "800 meters"],
      ans: 0
    },
    q16: {
      string: "16. A train covers a distance of 192 km at a uniform speed. If the speed of the train is 64 km/h, what is the time taken by the train?",
      options: ["2.5 hours", "3 hours", "3.5 hours", "4 hours"],
      ans: 2
    },
    q17: {
      string: "17. A train is running at a speed of 80 km/h. How long will it take to cover a distance of 1000 meters?",
      options: ["50 seconds", "60 seconds", "70 seconds", "80 seconds"],
      ans: 1
    },
    q18: {
      string: "18. Two trains of lengths 120 meters and 180 meters are running at speeds of 36 km/h and 54 km/h respectively in opposite directions. In how many seconds will they cross each other?",
      options: ["12 seconds", "15 seconds", "18 seconds", "20 seconds"],
      ans: 2
    },
    q19: {
      string: "19. A train passes a stationary man in 3 seconds and passes a stationary pole in 2 seconds. What is the length of the train if the speed of the train is 72 km/h?",
      options: ["40 meters", "50 meters", "60 meters", "70 meters"],
      ans: 1
    },
    q20: {
      string: "20. A train covers a distance of 360 km at a uniform speed. If the speed of the train is 90 km/h, how long will it take to cover the distance?",
      options: ["3 hours", "4 hours", "5 hours", "6 hours"],
      ans: 0
    },
    q21: {
      string: "21. A train is running at a speed of 108 km/h. How far will it travel in 20 minutes?",
      options: ["35 km", "40 km", "45 km", "50 km"],
      ans: 1
    },
    q22: {
      string: "22. Two trains of lengths 140 meters and 180 meters are running at speeds of 45 km/h and 60 km/h respectively in the same direction. In how many seconds will the faster train cross the slower one?",
      options: ["12 seconds", "15 seconds", "18 seconds", "20 seconds"],
      ans: 0
    },
    q23: {
      string: "23. A train covers a distance of 360 km at a uniform speed. If the speed of the train is 72 km/h, what is the time taken by the train?",
      options: ["4 hours", "5 hours", "6 hours", "7 hours"],
      ans: 1
    },
    q24: {
      string: "24. A train is running at a speed of 108 km/h. How long will it take to cover a distance of 3.6 km?",
      options: ["2 minutes", "3 minutes", "4 minutes", "5 minutes"],
      ans: 0
    },
    q25: {
      string: "25. Two trains of lengths 120 meters and 180 meters are running at speeds of 54 km/h and 72 km/h respectively in opposite directions. In how many seconds will they cross each other?",
      options: ["10 seconds", "12 seconds", "15 seconds", "18 seconds"],
      ans: 1
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>APTITUDE <span>TRAIN-PROBLEMS</span> </h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
